import { useTranslation } from 'react-i18next';
import { MessageSquare, RefreshCw, Plus, Battery, DollarSign, Smartphone, Slash, Box, Clock, MessageCircle, MoreVertical } from 'lucide-react';

// Extraído de ClientsView.jsx (02.3-client.md paso b) -- la vista Cosmic/Telefónica: KPIs +
// tabla de líneas o historial, según `cosmicViewMode`. Distinto de `CosmicClient.jsx` (el
// overlay de detalle de UNA línea) -- esto es la lista/tablero, no el detalle. Presentacional:
// `onLineClick` reemplaza el `navigate(...)` directo que vivía acá (nada de `react-router-dom`
// en una hoja).
export default function CosmicPipelinePanel({
  adintelliData,
  cosmicViewMode,
  onSetCosmicViewMode,
  cosmicCounts,
  historyOps,
  ops,
  opsTotal,
  currentPage,
  onPrevPage,
  onNextPage,
  onGlobalAction,
  onLineClick,
}) {
  const { t } = useTranslation('client');
  const countInventario = cosmicCounts.inventario;
  const countSuspendidas = cosmicCounts.suspendidas;
  const countActivas = cosmicCounts.activas;

  return (
    <div className="cosmic-telefonica-view" style={{ padding: '0 var(--space-4)', paddingBottom: 'var(--space-8)' }}>
      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 'var(--space-4)', marginBottom: 'var(--space-6)', marginTop: 'var(--space-4)' }}>
        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-4)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 'var(--space-2)' }}>{t('cosmic.kpis.generalBalance')}</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff', marginBottom: 'var(--space-2)', display: 'flex', alignItems: 'baseline' }}>
            ${adintelliData.balance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).split('.')[0]}.<span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', marginLeft: '1px' }}>{adintelliData.balance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).split('.')[1]}</span>
          </div>
          <div style={{ fontSize: '11px', color: '#10b981' }}>{t('cosmic.kpis.currentBalance')}</div>
          <div style={{ position: 'absolute', top: '16px', right: '16px', color: 'rgba(255,255,255,0.2)' }}><DollarSign size={20} /></div>
        </div>
        <div
          onClick={() => onSetCosmicViewMode('activas')}
          style={{
            background: cosmicViewMode === 'activas' ? 'rgba(59,130,246,0.1)' : 'rgba(255,255,255,0.03)',
            border: `1px solid ${cosmicViewMode === 'activas' ? '#3b82f6' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-4)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            cursor: 'pointer',
            transform: cosmicViewMode === 'activas' ? 'scale(0.98)' : 'scale(1)',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ fontSize: '10px', fontWeight: '600', color: cosmicViewMode === 'activas' ? '#3b82f6' : 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 'var(--space-2)' }}>{t('cosmic.kpis.activeLines')}</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff', marginBottom: 'var(--space-2)' }}>{countActivas}</div>
          <div style={{ fontSize: '11px', color: cosmicViewMode === 'activas' ? '#3b82f6' : '#10b981' }}>{t('cosmic.kpis.operatingLines')}</div>
          <div style={{ position: 'absolute', top: '16px', right: '16px', color: cosmicViewMode === 'activas' ? '#3b82f6' : 'rgba(255,255,255,0.2)' }}><Smartphone size={20} /></div>
        </div>
        <div
          onClick={() => onSetCosmicViewMode('suspendidas')}
          style={{
            background: cosmicViewMode === 'suspendidas' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(255,255,255,0.03)',
            border: `1px solid ${cosmicViewMode === 'suspendidas' ? '#ef4444' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-4)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            cursor: 'pointer',
            transform: cosmicViewMode === 'suspendidas' ? 'scale(0.98)' : 'scale(1)',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ fontSize: '10px', fontWeight: '600', color: cosmicViewMode === 'suspendidas' ? '#ef4444' : 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 'var(--space-2)' }}>{t('cosmic.kpis.suspended')}</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff', marginBottom: 'var(--space-2)' }}>{countSuspendidas}</div>
          <div style={{ fontSize: '11px', color: '#ef4444' }}>{t('cosmic.kpis.needsAttention')}</div>
          <div style={{ position: 'absolute', top: '16px', right: '16px', color: cosmicViewMode === 'suspendidas' ? '#ef4444' : 'rgba(255,255,255,0.2)' }}><Slash size={20} /></div>
        </div>
        <div
          onClick={() => onSetCosmicViewMode('inventario')}
          style={{
            background: cosmicViewMode === 'inventario' ? 'rgba(249, 115, 22, 0.1)' : 'rgba(255,255,255,0.03)',
            border: `1px solid ${cosmicViewMode === 'inventario' ? '#f97316' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-4)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            cursor: 'pointer',
            transform: cosmicViewMode === 'inventario' ? 'scale(0.98)' : 'scale(1)',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ fontSize: '10px', fontWeight: '600', color: cosmicViewMode === 'inventario' ? '#f97316' : 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 'var(--space-2)' }}>{t('cosmic.kpis.inventory')}</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff', marginBottom: 'var(--space-2)' }}>{countInventario}</div>
          <div style={{ fontSize: '11px', color: '#f97316' }}>{t('cosmic.kpis.inactiveChips')}</div>
          <div style={{ position: 'absolute', top: '16px', right: '16px', color: cosmicViewMode === 'inventario' ? '#f97316' : 'rgba(255,255,255,0.2)' }}><Box size={20} /></div>
        </div>
        <div
          onClick={() => onSetCosmicViewMode('historial')}
          style={{
            background: cosmicViewMode === 'historial' ? 'rgba(168, 85, 247, 0.1)' : 'rgba(255,255,255,0.03)',
            border: `1px solid ${cosmicViewMode === 'historial' ? '#a855f7' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-4)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            cursor: 'pointer',
            transform: cosmicViewMode === 'historial' ? 'scale(0.98)' : 'scale(1)',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ fontSize: '10px', fontWeight: '600', color: cosmicViewMode === 'historial' ? '#a855f7' : 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginBottom: 'var(--space-2)' }}>{t('cosmic.kpis.history')}</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff', marginBottom: 'var(--space-2)' }}>{historyOps.length}</div>
          <div style={{ fontSize: '11px', color: '#a855f7' }}>{t('cosmic.kpis.operations')}</div>
          <div style={{ position: 'absolute', top: '16px', right: '16px', color: cosmicViewMode === 'historial' ? '#a855f7' : 'rgba(255,255,255,0.2)' }}><Clock size={20} /></div>
        </div>
      </div>

      {/* Action Buttons & Toggle */}
      <div style={{ display: 'flex', gap: 'var(--space-3)', marginBottom: 'var(--space-6)' }}>
        <button
          onClick={() => onGlobalAction('activacion')}
          style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: 'var(--space-2) var(--space-4)', borderRadius: 'var(--radius-md)', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}
        >
          <Plus size={14} /> {t('cosmic.actions.newActivation')}
        </button>
        <button
          onClick={() => onGlobalAction('recarga')}
          style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: 'var(--space-2) var(--space-4)', borderRadius: 'var(--radius-md)', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}
        >
          <Battery size={14} /> {t('cosmic.actions.recharge')}
        </button>
        <button
          onClick={() => onGlobalAction('portabilidad')}
          style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: 'var(--space-2) var(--space-4)', borderRadius: 'var(--radius-md)', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}
        >
          <RefreshCw size={14} /> {t('cosmic.actions.portability')}
        </button>
      </div>

      {/* Table / History */}
      {cosmicViewMode === 'historial' ? (
        <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: 'var(--radius-md)', overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '150px 120px 1.5fr 150px', background: 'rgba(255,255,255,0.05)', padding: 'var(--space-3) var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: '11px', fontWeight: '600', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>
            <div>{t('cosmic.historyTable.date')}</div>
            <div>{t('cosmic.historyTable.line')}</div>
            <div>{t('cosmic.historyTable.description')}</div>
            <div>{t('cosmic.historyTable.event')}</div>
          </div>
          <div>
            {historyOps.length === 0 ? (
              <div style={{ padding: 'var(--space-8)', textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '13px' }}>{t('cosmic.historyTable.empty')}</div>
            ) : historyOps.map(h => (
              <div key={h.id} style={{ display: 'grid', gridTemplateColumns: '150px 120px 1.5fr 150px', padding: 'var(--space-3) var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.05)', alignItems: 'center' }}>
                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>{new Date(h.created_at).toLocaleString('es-MX')}</div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#fff' }}>{h.line}</div>
                <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>{h.description}</div>
                <div>
                  <span style={{ background: h.event_type === 'recarga' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(59, 130, 246, 0.1)', color: h.event_type === 'recarga' ? '#10b981' : '#3b82f6', padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-sm)', fontSize: '10px', fontWeight: '600', textTransform: 'uppercase' }}>
                    {h.event_type}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
      <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: 'var(--radius-md)', overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '120px 1.5fr 1fr 100px 130px 2fr 50px 50px', background: 'rgba(255,255,255,0.05)', padding: 'var(--space-3) var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: '11px', fontWeight: '600', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>
          <div>{t('cosmic.linesTable.line')}</div>
          <div>{t('cosmic.linesTable.titular')}</div>
          <div>{t('cosmic.linesTable.plan')}</div>
          <div>{t('cosmic.linesTable.status')}</div>
          <div>{t('cosmic.linesTable.date')}</div>
          <div>{t('cosmic.linesTable.consumption')}</div>
          <div style={{ textAlign: 'center' }}><MessageSquare size={13} style={{opacity: 0.5}} /></div>
          <div style={{ textAlign: 'center' }}>{t('cosmic.linesTable.action')}</div>
        </div>
        <div>
          {ops.length === 0 ? (
            <div style={{ padding: 'var(--space-8)', textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '13px' }}>{t('cosmic.linesTable.empty')}</div>
          ) : ops.map(o => (
            <div
              key={o.id}
              onClick={() => onLineClick(o.line)}
              style={{ display: 'grid', gridTemplateColumns: '120px 1.5fr 1fr 100px 130px 2fr 50px 50px', padding: 'var(--space-3) var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.02)', fontSize: '13px', alignItems: 'center', cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.03)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{ color: '#fff', fontWeight: '500' }}>{o.line}</div>
              <div style={{ color: 'rgba(255,255,255,0.7)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingRight: 'var(--space-2)' }}>{o.holder || t('cosmic.linesTable.noName')}</div>
              <div style={{ color: 'rgba(255,255,255,0.7)' }}>{o.plan || t('cosmic.linesTable.noPlan')}</div>
              <div>
                {(() => {
                  const e = (o.status || '').toLowerCase();
                  let isInv = e === 'inactiva' || e === 'idle' || e === 'reserved';
                  if (!o.plan || o.plan.toLowerCase() === 'sin plan' || o.plan.toLowerCase() === 'sin_plan') isInv = true;

                  const isPre = e === 'pre desactivada';
                  let bg = isInv ? 'rgba(249, 115, 22, 0.1)' : isPre ? 'rgba(245, 158, 11, 0.1)' : (e === 'activo' || e === 'active' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)');
                  let col = isInv ? '#f97316' : isPre ? '#f59e0b' : (e === 'activo' || e === 'active' ? '#10b981' : '#ef4444');
                  const txt = isInv ? t('cosmic.linesTable.inactive') : (o.status || t('cosmic.linesTable.activeStatus'));

                  if (!isInv && !isPre && (e === 'activo' || e === 'active')) {
                    const d = parseInt(o.days_remaining) || 0;
                    if (d === 0) {
                      bg = 'rgba(239,68,68,0.1)';
                      col = '#ef4444';
                    } else if (d === 1) {
                      bg = 'rgba(234,179,8,0.1)';
                      col = '#eab308';
                    } else if (d === 2) {
                      bg = 'rgba(249,115,22,0.1)';
                      col = '#f97316';
                    }
                  }

                  return (
                    <span style={{
                      padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-lg)', fontSize: '10px', fontWeight: '700',
                      background: bg,
                      color: col,
                      textTransform: 'uppercase'
                    }}>
                      {txt}
                    </span>
                  );
                })()}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <span style={{ color: '#fff', fontSize: '12px', fontWeight: '600' }}>{o.days_remaining || 0} {t('cosmic.linesTable.days')}</span>
                <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '10px', textTransform: 'capitalize' }}>
                  {(() => {
                    if (!o.recharge_date) return t('cosmic.linesTable.loadingDate');
                    const parts = o.recharge_date.split('-');
                    if (parts.length === 3) {
                      const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                      return `${parts[2]} ${months[parseInt(parts[1])-1]} ${parts[0]}`;
                    }
                    return o.recharge_date;
                  })()}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
                <div style={{ flex: 1, height: '6px', background: 'rgba(255,255,255,0.1)', borderRadius: 'var(--radius-sm)', overflow: 'hidden' }}>
                   <div style={{ height: '100%', width: `${o.total_gb > 0 ? (o.consumption_gb / o.total_gb) * 100 : 0}%`, background: '#3b82f6', borderRadius: 'var(--radius-sm)' }}></div>
                </div>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)', whiteSpace: 'nowrap' }}>
                  <span style={{ color: '#fff', fontWeight: '600' }}>{o.total_gb > 0 ? Math.round((o.consumption_gb / o.total_gb) * 100) : 0}%</span> · {o.total_gb > 0 ? Math.max(0, o.total_gb - o.consumption_gb).toFixed(1) : 0} {t('cosmic.linesTable.gbLeft')}
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button aria-label={t('cosmic.linesTable.messagesAriaLabel')} style={{ background: 'transparent', border: 'none', color: o.message ? '#3b82f6' : 'rgba(255,255,255,0.3)', cursor: 'pointer' }}><MessageCircle size={14} /></button>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
                <button aria-label={t('cosmic.linesTable.moreActionsAriaLabel')} style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}><MoreVertical size={16} /></button>
              </div>
            </div>
          ))}
        </div>
        {opsTotal > 120 && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-4)', gap: 'var(--space-4)', alignItems: 'center', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <button
              onClick={onPrevPage}
              disabled={currentPage === 1}
              style={{ background: 'rgba(255,255,255,0.05)', color: currentPage === 1 ? 'rgba(255,255,255,0.3)' : '#fff', border: 'none', padding: 'var(--space-2) var(--space-3)', borderRadius: 'var(--radius-sm)', cursor: currentPage === 1 ? 'default' : 'pointer' }}
            >{t('cosmic.pagination.previous')}</button>
            <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>{t('cosmic.pagination.page', { current: currentPage, total: Math.ceil(opsTotal / 120) })}</span>
            <button
              onClick={onNextPage}
              disabled={currentPage >= Math.ceil(opsTotal / 120)}
              style={{ background: 'rgba(255,255,255,0.05)', color: currentPage >= Math.ceil(opsTotal / 120) ? 'rgba(255,255,255,0.3)' : '#fff', border: 'none', padding: 'var(--space-2) var(--space-3)', borderRadius: 'var(--radius-sm)', cursor: currentPage >= Math.ceil(opsTotal / 120) ? 'default' : 'pointer' }}
            >{t('cosmic.pagination.next')}</button>
          </div>
        )}
      </div>
      )}
    </div>
  );
}
